module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-terra-barocca.svg?c8e0311e1c6de195ed4be4422e84906c";